export default __webpack_public_path__ + "static/media/Credit_Card_Safe_light.25ac467a.png";